import { buildPathsToDescendants, getNegativeCondition } from "./helpers";
import { NO_MATCH, POSITIVE_MATCH, NEGATIVE_MATCH, DEFAULT_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkMatchChildPath(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.matchChildPath) {
    return NO_MATCH;
  }

  const descendantPaths = buildPathsToDescendants(node);

  const negativeConditions = nodeCondition.matchChildPath
    .map((c) => getNegativeCondition(c))
    .filter(Boolean);
  const positiveConditions = nodeCondition.matchChildPath.filter((c) => !getNegativeCondition(c));

  for (const pathCondition of negativeConditions) {
    const regex = new RegExp(pathCondition);
    if (descendantPaths.some((p) => regex.test(p))) {
      return NEGATIVE_MATCH;
    }
  }

  for (const pathCondition of positiveConditions) {
    const regex = new RegExp(pathCondition);
    if (descendantPaths.some((p) => regex.test(p))) {
      return POSITIVE_MATCH;
    }
  }

  // Only negative conditions with no match: explicitly not excluded
  if (negativeConditions.length > 0 && positiveConditions.length === 0) {
    return DEFAULT_MATCH;
  }

  return NO_MATCH;
}
